import Model from '../core/model';
import PointHighlight from './point-highlight';
import SeriesHighlight from './series-highlight';
import PointHighlightByX from './point-highlight-by-axis';
import PointLink from './point-link';
import AxisLabelHighlight from './axis-label-highlight';
export default Model;
var interactionStorage = {};
export function createInteraction(chart, name, userOption) {
    var Interaction = interactionStorage[name];
    if (!Interaction) {
        throw new Error("interaction '" + name + "' not exist");
    }
    var instance = new Interaction(userOption);
    instance.chart = chart;
    instance.mounted();
    return instance;
}
export function registerInteraction(name, InterfactionClass) {
    interactionStorage[name] = InterfactionClass;
}
registerInteraction('point-highlight', PointHighlight);
registerInteraction('series-highlight', SeriesHighlight);
registerInteraction('point-highlight-by-axis', PointHighlightByX);
registerInteraction('point-link', PointLink);
registerInteraction('axis-label-highlight', AxisLabelHighlight);
